__turbopack_context__.v({
  "isLoggingOut": "transition-logo-module__LXoFga__isLoggingOut",
  "isNavigating": "transition-logo-module__LXoFga__isNavigating",
  "transition-logo-fade-in": "transition-logo-module__LXoFga__transition-logo-fade-in",
  "transitionLogo": "transition-logo-module__LXoFga__transitionLogo",
  "transitionLogoSpacer": "transition-logo-module__LXoFga__transitionLogoSpacer",
});
